var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 800,
    viewBox: "0 0 1512 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1533.87 -54L888 909",
    stroke: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 -36L594 920",
    stroke: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_5799)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.389648,
    y: 586,
    width: 730.698,
    height: 645.009,
    rx: 40,
    transform: "rotate(23.1317 0.389648 586)",
    fill: "#E8664C"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 436.133,
    y: 717.774,
    width: 520.69,
    height: 751.158,
    rx: 40,
    transform: "rotate(103.924 436.133 717.774)",
    fill: "#FF6F53"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_513_5799)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1020.29,
    y: 707,
    width: 626,
    height: 663,
    rx: 40,
    transform: "rotate(13.1906 1020.29 707)",
    fill: "#E8664C"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 1472.24,
    y: 761.571,
    width: 520.69,
    height: 751.157,
    rx: 40,
    transform: "rotate(93.9827 1472.24 761.571)",
    fill: "#FF6F53"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 650.426,
    height: 574.42,
    rx: 40,
    transform: "matrix(0.706858 0.707355 -0.78172 0.623629 86.4795 526)",
    fill: "#FDB75D"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 505.429,
    height: 732.932,
    rx: 40,
    transform: "matrix(-0.383338 0.923608 -0.949249 -0.314524 419.485 867.607)",
    fill: "#FD9B38"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 626.516,
    height: 470.6,
    rx: 40,
    transform: "matrix(0.390925 0.920422 -0.947041 0.321111 1515.68 639)",
    fill: "#FDA343"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 522.371,
    height: 838.526,
    rx: 40,
    transform: "matrix(0.178515 0.983937 -0.989673 0.143344 1930.87 618)",
    fill: "#FF6F53"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_513_5799)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 710.628,
    y: 552,
    width: 579.193,
    height: 589.572,
    rx: 40,
    transform: "rotate(34.9364 710.628 552)",
    fill: "#E8664C"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 1069.72,
    y: 801.083,
    width: 520.69,
    height: 751.157,
    rx: 40,
    transform: "rotate(115.728 1069.72 801.083)",
    fill: "#FF6F53"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 505.429,
    height: 504.02,
    rx: 40,
    transform: "matrix(-0.602659 0.797999 -0.840074 -0.542472 1186 1063.54)",
    fill: "#FD9B38"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_5799"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.389648,
    y: 586,
    width: 730.698,
    height: 645.009,
    rx: 40,
    transform: "rotate(23.1317 0.389648 586)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_513_5799"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1020.29,
    y: 707,
    width: 626,
    height: 663,
    rx: 40,
    transform: "rotate(13.1906 1020.29 707)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_513_5799"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 710.628,
    y: 552,
    width: 579.193,
    height: 589.572,
    rx: 40,
    transform: "rotate(34.9364 710.628 552)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.2eb41d1a4e94744a9abafa946b011777.svg";
export { ForwardRef as ReactComponent };